/* eslint-disable i18next/no-literal-string */

import { Box, Typography } from "@outschool/backpack";
import React from "react";

import { AVATAR_STYLES } from "./avatar-builder-constants";
import { ChipButton } from "./AvatarBuilderFormControls";

export interface AvatarBuilderArtStyleTabProps {
  artStyle: string;
  setArtStyle: React.Dispatch<React.SetStateAction<string>>;
}

export function AvatarBuilderArtStyleTab({
  artStyle,
  setArtStyle,
}: AvatarBuilderArtStyleTabProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <Typography
        variant="subtitle2"
        sx={{ fontSize: "1.5rem", fontWeight: 600 }}
      >
        Style
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
          gap: 8,
        }}
      >
        {AVATAR_STYLES.map(style => (
          <ChipButton
            key={style.value}
            label={style.label}
            description={style.description}
            selected={artStyle === style.value}
            onClick={() => setArtStyle(style.value)}
          />
        ))}
      </Box>
    </Box>
  );
}
